import { id as _id, Id, ModuleCategory } from '@ess/jg-rule-executor';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { ModuleCategoryInput } from '@src/app/generated/globalTypes';
import { GetAllModuleCategorySettings_allModuleCategorySettings } from '@src/app/generated/GetAllModuleCategorySettings';
import { PortalCategoryBlueprint } from '@src/app/model/portal-category-blueprint';
import { JsonProperty } from 'ta-json';

export class PortalModuleCategory implements ToJsonInputTranslatable {
  @JsonProperty() reference: string;
  @JsonProperty() id: Id<ModuleCategory>;
  @JsonProperty() order: number;
  @JsonProperty() customizable: boolean;
  @JsonProperty() moduleBlueprints: PortalCategoryBlueprint[];

  constructor(
    id?: string,
    reference?: string,
    order?: number,
    customizable?: boolean,
    moduleBlueprints?: PortalCategoryBlueprint[]
  ) {
    this.id = _id(id);
    this.reference = reference;
    this.order = order;
    this.customizable = customizable;
    this.moduleBlueprints = moduleBlueprints;
  }

  toGqlInput(): ModuleCategoryInput {
    return {
      id: this.id,
      reference: this.reference,
      order: this.order,
      customizable: this.customizable,
    };
  }

  static fromGql(gql: GetAllModuleCategorySettings_allModuleCategorySettings): PortalModuleCategory {
    return new PortalModuleCategory(
      gql.id,
      gql.reference,
      gql.order,
      gql.customizable,
      gql.blueprints.map(bp => PortalCategoryBlueprint.fromGql(bp))
    );
  }
}
